import { NavLink, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth';
import { ProductsPage } from './pages/ProductsPage';
import { StrategiesPage } from './pages/StrategiesPage';
import { StrategyEditPage } from './pages/StrategyEditPage';
import { StrategyProductsPage } from './pages/StrategyProductsPage';
import { SyncPage } from './pages/SyncPage';
import { SettingsPage } from './pages/SettingsPage';
import { LoginPage } from './pages/LoginPage';

export function App() {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
}

function AppShell() {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) return <div style={{ padding: 32 }}>Загрузка…</div>;

  if (!user) {
    if (loc.pathname !== '/login') return <Navigate to="/login" replace />;
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Залогинен
  if (loc.pathname === '/login') return <Navigate to="/products" replace />;

  return (
    <div className="app-shell">
      <Sidebar />
      <main className="content">
        <Routes>
          <Route path="/" element={<Navigate to="/products" replace />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/strategies" element={<StrategiesPage />} />
          <Route path="/strategies/new" element={<StrategyEditPage />} />
          <Route path="/strategies/:id" element={<StrategyEditPage />} />
          <Route path="/strategies/:id/products" element={<StrategyProductsPage />} />
          <Route path="/sync" element={<SyncPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </main>
    </div>
  );
}

function Sidebar() {
  const { user, logout } = useAuth();
  return (
    <aside className="sidebar">
      <h1>Ozon Repricer</h1>
      <nav>
        <NavLink to="/products" className={({ isActive }) => (isActive ? 'active' : '')}>Товары</NavLink>
        <NavLink to="/strategies" className={({ isActive }) => (isActive ? 'active' : '')}>Стратегии</NavLink>
        <NavLink to="/sync" className={({ isActive }) => (isActive ? 'active' : '')}>Синхронизация</NavLink>
        <NavLink to="/settings" className={({ isActive }) => (isActive ? 'active' : '')}>Настройки</NavLink>
      </nav>
      <div style={{ position: 'absolute', bottom: 16, left: 16, right: 16, fontSize: 12 }}>
        <div style={{ marginBottom: 8, color: '#94a3b8' }}>
          {user?.email}
          <div style={{ fontSize: 11, opacity: 0.6 }}>{user?.role === 'admin' ? 'администратор' : 'просмотр'}</div>
        </div>
        <button
          onClick={() => logout()}
          style={{ background: 'transparent', border: '1px solid #334155', color: '#cbd5e1', padding: '6px 12px', borderRadius: 4, cursor: 'pointer', width: '100%' }}
        >
          Выйти
        </button>
      </div>
    </aside>
  );
}
